module.exports = __webpack_public_path__ + "media/images/slides/sorciere-7fb12c8c5476f0b7e48961c8cde778ff.jpg";